// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

// // 接続先環境(DEV,STG,PROD)
// const ENVIRONMENT: String = 'DEV';
// const ENVIRONMENT: String = 'STG';
const ENVIRONMENT: String = 'PROD';

// API Gateway接続先（Dev)
const API_GATEWAY_URI_DEV = 'https://emlvieoy80.execute-api.ap-northeast-1.amazonaws.com/v1';
// API Gateway接続先（STG)
const API_GATEWAY_URI_STG = 'https://343sbkvqjc.execute-api.ap-northeast-1.amazonaws.com/v1';
// API Gateway接続先（PROD)
const API_GATEWAY_URI_PROD = 'https://zhjsxixgfd.execute-api.ap-northeast-1.amazonaws.com/v1';

export function apiGatewayUri() {
  let uri;
  switch (ENVIRONMENT) {
    case 'DEV':
      return uri = API_GATEWAY_URI_DEV;

    case 'STG':
      return uri = API_GATEWAY_URI_STG;

    case 'PROD':
      return uri = API_GATEWAY_URI_PROD;

    default:
      return uri;
  }
}


export function awsFaqUrl() {
  let FAQ_URL = '';

  switch (ENVIRONMENT) {
    case 'DEV':
      FAQ_URL = 'https://dev-ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/faq.json';
      return FAQ_URL;

    case 'STG':
      FAQ_URL = 'https://stg-ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/faq.json';
      return FAQ_URL;

    case 'PROD':
      FAQ_URL = 'https://ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/faq.json';
      return FAQ_URL;

    default:
      return FAQ_URL;
  }
}

export function awsUserPolicyUrl() {
  let USER_POLICY_URL = '';

  switch (ENVIRONMENT) {
    case 'DEV':
      USER_POLICY_URL = 'https://dev-ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/userPolicy.json';
      return USER_POLICY_URL;

    case 'STG':
      USER_POLICY_URL = 'https://stg-ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/userPolicy.json';
      return USER_POLICY_URL;

    case 'PROD':
      USER_POLICY_URL = 'https://ain-mobile-app-info.s3-ap-northeast-1.amazonaws.com/userPolicy.json';
      return USER_POLICY_URL;

    default:
      return USER_POLICY_URL;
  }
}

export function awsItemInfo() {
  let ITEM_INFO_URL = '';

  switch (ENVIRONMENT) {
    case 'DEV':
      ITEM_INFO_URL = 'https://dev-app-new-item.ainztulpe.jp/';
      return ITEM_INFO_URL;

    case 'STG':
      ITEM_INFO_URL = 'https://stg-app-new-item.ainztulpe.jp/';
      return ITEM_INFO_URL;

    case 'PROD':
      ITEM_INFO_URL = 'https://app-new-item.ainztulpe.jp/';
      return ITEM_INFO_URL;

    default:
      return ITEM_INFO_URL;
  }
}

export function awsLdkContentInfo() {
  let LDK_CONTENT_INFO_URL = '';

  switch (ENVIRONMENT) {
    case 'DEV':
      LDK_CONTENT_INFO_URL = 'https://dev-ain-mobile-app-ldk.s3-ap-northeast-1.amazonaws.com/content/';
      return LDK_CONTENT_INFO_URL;
    case 'STG':
      LDK_CONTENT_INFO_URL = 'https://stg-ain-mobile-app-ldk.s3-ap-northeast-1.amazonaws.com/content/';
      return LDK_CONTENT_INFO_URL;

    case 'PROD':
      LDK_CONTENT_INFO_URL = 'https://ain-mobile-app-ldk.s3-ap-northeast-1.amazonaws.com/content/';
      return LDK_CONTENT_INFO_URL;

    default:
      return LDK_CONTENT_INFO_URL;
  }
}
